import { c as _c } from "react/compiler-runtime";
import { GrantItemSkeleton } from "./UserPageXtdhGrantListItem/subcomponents/GrantItemSkeleton";
import { GrantListItemContainer } from "./UserPageXtdhGrantListItem/subcomponents/GrantListItemContainer";
export function GrantedListSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="tw-m-0 tw-flex tw-flex-col tw-gap-3 tw-p-0">{Array.from({
        length: 3
      }).map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, i) {
  return <GrantListItemContainer key={i}><GrantItemSkeleton /></GrantListItemContainer>;
}